import gsap from "gsap/all";
import throttle from "lodash.throttle";

export default () => ({
  tl: null,
  tlReverse: null,

  header: document.querySelector("header"),
  animationDuration: { duration: 0.2 },

  init() {
    this.checkActiveState();
    this.checkScrollState();
  },

  checkActiveState() {
    try {
      this.$refs.mainNav.querySelectorAll('.current, .active').forEach((item) => {
        item.parentNode.classList.remove('current', 'active');
      });

      let pathname = document.location.pathname;

      // product shareclass links..
      let shareclassLink = document.querySelector('.product-tags a');
      if (shareclassLink) {
        if (document.querySelector('.product-tags a[href^="' + pathname + '"]')) {

          document.querySelectorAll('.product-tags a[href^="' + pathname + '"]').forEach((item) => {
            item.classList.add('active');
          });

          pathname = shareclassLink.getAttribute('href').split('#')[0];
        }
      }

      // normal nav links..
      this.$refs.mainNav.querySelectorAll('a[href="' + pathname + '"]').forEach((item) => {
        item.parentNode.classList.add('current');
        item.closest('.nav-item').classList.add('active');
      });

      const pathSegments = pathname.substring(1).split('/');
      pathSegments.pop();
      while (pathSegments.length > 0) {
        console.log('check /' + pathSegments.join('/'));
        this.$refs.mainNav.querySelectorAll('a[href="/' + pathSegments.join('/') + '"]').forEach((item) => {
          item.parentNode.classList.add('active');
        });

        pathSegments.pop();
      }
    } catch (e) {
      console.log(e);
    }
  },

  checkScrollState() {
    window.addEventListener(
      "scroll",
      throttle(() => {
        const hasScrolled = window.scrollY > 0;
        const menuElement = document.querySelector(
          ".nav-item .is-open .desktop-menu"
        );

        // close desktop menu when user has scrolled and menu is open
        if (hasScrolled && menuElement) {
          this.reverseHeaderExpansion(menuElement, true);
        }
      }, 200)
    );
  },

  itemLevel0: {
    ["@mouseover.stop"](event) {
      const menuElement = event.target.querySelector(".desktop-menu");

      if (menuElement && menuElement.classList.contains("desktop-menu")) {
        this.expandHeader(event.target, menuElement);
      }
    },

    ["@mouseleave.stop"](event) {
      const menuElement = event.target.querySelector(".desktop-menu");

      if (menuElement) {
        this.reverseHeaderExpansion(menuElement);
        this.resetSVGHitArea(event.target);
      }
    },

    ["@click"](event) {
      // prevent click when NO touch device
      if (!("ontouchstart" in document.documentElement)) return;

      const menuElement = this.header.querySelector(".desktop-menu");

      if (menuElement.classList.contains("hidden")) {
        this.expandHeader(event.target, menuElement);
      } else {
        this.reverseHeaderExpansion(menuElement);
      }
    },
  },

  expandHeader(anchor, menuElement) {
    if (this.tl) {
      this.tl.kill();
    }

    anchor.classList.add("is-open");
    menuElement.classList.remove("hidden");
    menuElement.scrollTop = 0;

    this.tl = gsap
      .timeline({
        defaults: {
          ...this.animationDuration,

          onComplete: () => {
            this.checkIfScrollable(menuElement);
          },
        },
      })
      .to(menuElement, {
        onStart: () => {
          // draw hit area after desktop menu has showed up
          this.drawSVGHitArea(anchor.firstChild, menuElement);
        },
        duration: 0.1,
      })
      .to(
        menuElement,
        {
          opacity: 1,
        },
        0
      )
      .to(
        menuElement,
        {
          boxShadow: "0px 85px 55px -60px rgba(49, 49, 49, 0.65)",
        },
        "<"
      );
  },

  reverseHeaderExpansion(menuElement, instant) {
    this.tl.kill();

    this.tlReverse = gsap
      .timeline({
        defaults: {
          duration: instant ? 0.1 : this.animationDuration.duration,
        },
        onComplete: () => {
          menuElement.classList.add("hidden");
          menuElement.parentNode.classList.remove("is-open");
        },
      })
      .to(menuElement, {
        opacity: 0,
      });
  },

  drawSVGHitArea(el, menuElement) {
    const curveFactor = 20;
    const anchor = el.getBoundingClientRect();
    const menu = menuElement.getBoundingClientRect();
    const svg = el.parentNode
      .querySelector(".hit-area")
      .getBoundingClientRect();

    const anchorTop = svg.bottom - anchor.bottom;
    const anchorBottom = anchorTop + anchor.height;
    const menuTop = svg.bottom - menu.top;

    // draw svg hit area
    el.parentNode.querySelector(".hit-area path").setAttribute(
      "d",
      `
        M ${anchor.left + anchor.width - menu.left} ${anchorBottom}
        Q ${anchor.left + anchor.width - menu.left + curveFactor} ${menuTop},
          ${menu.right - menu.left} ${menuTop}
          ${menu.left} ${menuTop}
        0 ${menuTop}
        Q ${anchor.left - menu.left - curveFactor} ${menuTop},
          ${anchor.left - menu.left} ${anchorBottom}
          ${anchor.left - menu.left} ${anchorTop}
          ${anchor.left - menu.left} ${anchorTop}
          ${anchor.left + anchor.width - menu.left} ${anchorTop}
          ${anchor.left + anchor.width - menu.left} ${anchorTop}
        z
      `
    );
  },

  resetSVGHitArea(el) {
    el.parentNode.querySelector(".hit-area path").setAttribute("d", "");
  },

  checkIfScrollable(menu) {
    menu.addEventListener("mouseover", () => {
      const menuIsScrollable = menu.scrollHeight > menu.clientHeight;

      if (menuIsScrollable) {
        document.body.classList.add("overflow-hidden");
      }
    });

    menu.addEventListener("mouseleave", () => {
      document.body.classList.remove("overflow-hidden");
    });
  },
});
